import React from "react";
import CustomImage from "../../atoms/customImage";
import PropType from "prop-types";
import { PRODUCT_VIDEO_POSITION } from "../../../constants/pageConstants/pdpConstants";

/**
 * Renders the footer component that displays product images and handles image click events.
 *
 * @param {Object} props - The properties object for the footer component.
 * @param {Array} props.productImages - An array of product image objects to be displayed in the footer.
 * @param {Function} props.onclick - The callback function triggered on a generic click event.
 * @param {Function} props.imageClick - The callback function triggered when a product image is clicked.
 *
 * @returns {JSX.Element} The footer component with product images and click handlers.
 */
const ZoomGalleryFooter = ({ productImages, onImageClick, imageClick, productVideoLink }) => {
  const imageDomain = process.env.NEXT_PUBLIC_IMAGE_DOMAIN;

  /**
   * @param {string} item - consist url of image
   * @returns {JSX.Element} A JSX element containing CustomImage.
   */
  const renderImage = (item, index) => {
    const renderedItemUrl = index !== PRODUCT_VIDEO_POSITION || !productVideoLink ? imageDomain + item : item;
    const imageSrc =
      index !== PRODUCT_VIDEO_POSITION || !productVideoLink ? imageDomain + item : imageDomain + productImages?.[0];
    return (
      <div
        onClick={() => onImageClick(item, index)}
        key={index}
        className={`relative h-max flex-none cursor-pointer rounded-lg md:flex ${imageClick === renderedItemUrl && "ring-2 ring-fnp-400"}`}
      >
        {index === PRODUCT_VIDEO_POSITION && productVideoLink && (
          <>
            <div className="absolute h-full w-full rounded-[6.4px] bg-black-900 opacity-30" />
            <div className="absolute flex h-full w-full justify-center">
              <CustomImage
                src={imageClick === renderedItemUrl ? "/icons/drawer-close.svg" : "/icons/play.svg"}
                alt="Play"
                width={40}
                height={40}
                sizes="10vw"
                isPriority={false}
                itemProp="image"
                className="m-auto"
              />
            </div>
          </>
        )}
        <CustomImage src={imageSrc} width={80} height={80} alt={item} sizes="50vw" borderRadius={8} itemProp="image" />
      </div>
    );
  };

  return (
    <>
      {productImages.map((item, index) => {
        return renderImage(item, index);
      })}
    </>
  );
};

ZoomGalleryFooter.propTypes = {
  productImages: PropType.array.isRequired,
  onImageClick: PropType.func,
  imageClick: PropType.string,
  productVideoLink: PropType.string,
};

export default ZoomGalleryFooter;
